export default __webpack_public_path__ + "static/media/sparkle.4a966825.svg";